"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
exports.__esModule = true;
exports.bindHooksToStore = void 0;
var util_1 = require("../util");
var getDependenciesChanged = function (from, to) {
    if (!to) {
        return true;
    }
    if (from === to) {
        return false;
    }
    else if (from.length !== to.length) {
        return true;
    }
    for (var i = 0; i < from.length; i++) {
        if (from[i] !== to[i]) {
            return true;
        }
    }
    return false;
};
var bindHook = function (store, hookName, hookFactory) {
    var hook = hookFactory(store);
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var cell = store.getCurrentCell();
        var result;
        if (cell && cell.length === 2) {
            // Cell has already been created
            var _a = __read(cell, 2), foundHookId = _a[0], contents = _a[1];
            if (foundHookId !== hookIds[hookName]) {
                util_1.throwError("Hooks called out of order.");
            }
            result = hook.call.apply(hook, __spread([contents], args));
            cell[1] = result;
        }
        else {
            // Cell is newly created.
            result = hook.call.apply(hook, __spread([null], args));
            cell[0] = hookIds[hookName];
            cell[1] = result;
        }
        store.incrementPointer();
        return result;
    };
};
exports.bindHooksToStore = function (store) {
    var boundHooks = {};
    for (var i = 0; i < hookEntries.length; i++) {
        var _a = __read(hookEntries[i], 2), hookName = _a[0], hookFn = _a[1];
        boundHooks[hookName] = bindHook(store, hookName, hookFn);
    }
    return boundHooks;
};
var hookFactories = {
    useState: function (store) {
        return function useState(initialValue) {
            if (this) {
                return this;
            }
            var contents = [
                typeof initialValue === "function" ? initialValue() : initialValue,
                function (arg) {
                    var currentValue = contents[0];
                    if (typeof arg === "function") {
                        contents[0] = arg(currentValue);
                    }
                    else {
                        contents[0] = arg;
                    }
                    if (currentValue !== contents[0]) {
                        store.invalidate();
                    }
                },
            ];
            return contents;
        };
    },
    useEffect: function (store) {
        return function useEffect(callback, dependencies) {
            var _this = this;
            if (this) {
                var _a = __read(this, 2), previousDependencies = _a[0], previousTeardown_1 = _a[1];
                var shouldRerun = getDependenciesChanged(previousDependencies, dependencies);
                if (shouldRerun) {
                    store.registerRunCallback(function () {
                        if (previousTeardown_1) {
                            previousTeardown_1();
                            store.unregisterDestroyCallback(previousTeardown_1);
                        }
                        var teardown = callback();
                        if (teardown) {
                            store.registerDestroyCallback(teardown);
                        }
                        _this[0] = dependencies;
                        _this[1] = teardown;
                    });
                }
                return this;
            }
            var contents = [];
            store.registerRunCallback(function () {
                var teardown = callback();
                if (teardown) {
                    store.registerDestroyCallback(teardown);
                }
                contents[0] = dependencies;
                contents[1] = teardown;
            });
            return contents;
        };
    },
    useRef: function () {
        return function useRef(initialValue) {
            if (this) {
                return this;
            }
            return { current: initialValue };
        };
    }
};
var hookEntries = Object.entries(hookFactories);
var hookIds = {};
hookEntries.forEach(function (_a, index) {
    var _b = __read(_a, 1), name = _b[0];
    hookIds[name] = index;
});
